import { useReducer } from 'react';

const MODAL_STATE_DEFAULT = { activeModal: null, pipeline: { cluster: {} } };

export const MODAL_ACTIONS = {
  EDIT_PIPELINE_NAME: 'EDIT_PIPELINE_NAME',
  DELETE_PIPELINE: 'DELETE_PIPELINE',
  OPEN_AUDIT_LOG: 'OPEN_AUDIT_LOG',
  CLOSE_MODAL: 'CLOSE_MODAL',
};

export default function useActiveModalState() {
  const [modalState, dispatch] = useReducer(modalReducer, MODAL_STATE_DEFAULT);

  const editPipelineName = pipeline => {
    dispatch({ type: MODAL_ACTIONS.EDIT_PIPELINE_NAME, pipeline });
  };

  const deletePipeline = pipeline => {
    dispatch({ type: MODAL_ACTIONS.DELETE_PIPELINE, pipeline });
  };

  const openAuditLog = pipeline => {
    dispatch({ type: MODAL_ACTIONS.OPEN_AUDIT_LOG, pipeline });
  };

  const closeModal = () => {
    dispatch({ type: MODAL_ACTIONS.CLOSE_MODAL });
  };

  return { modalState, editPipelineName, deletePipeline, openAuditLog, closeModal };
}

export function modalReducer(state, action) {
  switch (action.type) {
    case MODAL_ACTIONS.EDIT_PIPELINE_NAME:
      return {
        activeModal: MODAL_ACTIONS.EDIT_PIPELINE_NAME,
        pipeline: action.pipeline,
      };
    case MODAL_ACTIONS.DELETE_PIPELINE:
      return {
        activeModal: MODAL_ACTIONS.DELETE_PIPELINE,
        pipeline: action.pipeline,
      };
    case MODAL_ACTIONS.OPEN_AUDIT_LOG:
      return {
        activeModal: MODAL_ACTIONS.OPEN_AUDIT_LOG,
        pipeline: action.pipeline,
      };
    case MODAL_ACTIONS.CLOSE_MODAL:
      return { ...state, activeModal: null };
    default:
      return state;
  }
}
